import { Injectable } from '@angular/core';
import { Model } from '../shared/model';

const IPMap = {

}

@Injectable()
export class IP extends Model {
  // properties
  id                     ?: number | null
  connection_id           : number
  ip                      : string
  ip_index                : number
  hostname               ?: string
  label                   : string
  description            ?: string

  status                 ?: string = 'disconnected';
  editing                ?: boolean = false;
  relay                  ?: boolean = false;

  constructor(obj: IP) {
    super(obj);
  }
}

const VendorMap = {

}

@Injectable()
export class Vendor extends Model {
  // properties
  id                      : number | null
  name                    : string
  default_path            : string
  default_path_text				: string
  has_remote_desktop      : boolean
  has_reboot              : boolean
  method                  : string = 'tap'
  links										: any[]

  constructor(obj: Vendor) {
    super(obj);
  }
}

const ControllerMap = {

}

@Injectable()
export class Controller extends Model {
  // properties
  id                     ?: number
  device_id               : number
  allow_reboot           ?: boolean = true
  allow_remote_desktop   ?: boolean = true
  enabled                ?: boolean = true
  path                    : string
  subnet_mask            ?: string = '255.255.255.0'
  vendor_id               : number
  vendor                  : Vendor

  status                 ?: string = 'disconnected'

  // children
  ips                     : IP[] = []
  ip                     ?: IP
  activeIP               ?: IP

  constructor(obj: Controller) {
    super(obj);
    if (!obj.ips) obj.ips = [];
    obj.ips = obj.ips.map((ip) => new IP(ip));
    obj.vendor = new Vendor(obj.vendor);
    Object.assign(this, obj);
  }
}
